// 获取引擎当前相机视角
export const getCameraViewAngle = () => {
    let camLocate = window.BlackHole3D.Camera.getCamLocate();
    let { camDir, camPos, camRotate } = camLocate;
    camDir = camDir.map((el) => Number(el.toFixed(6)));
    camPos = camPos.map((el) => Number(el.toFixed(6)));
    camRotate = camRotate.map((el) => Number(el.toFixed(6)));
    let visualAngleObj = { camDir, camPos, camRotate };
    let visualAngle = JSON.stringify(visualAngleObj);
    return visualAngle;
}

/**
 * BIM相关方法
 */

// 显示数据集
export const showDataSet = (dataSetId, dataSetType, isFocus) => {
    const BlackHole3D = window.BlackHole3D;

    if (dataSetType !== 0) {
        BlackHole3D.Grid.setValidState(dataSetId, true);
    } else {
        BlackHole3D.BIM.resetElemAttr(dataSetId, []);
    }

    if (isFocus) {
        BlackHole3D.Camera.setCamLocateToDataSet(dataSetId, 1.0);
    }
}

// 隐藏数据集
export const hideDataSet = (dataSetId, dataSetType) => {
    const BlackHole3D = window.BlackHole3D;
    if (dataSetType !== 0) {
        BlackHole3D.Grid.setValidState(dataSetId, false);
    } else {
        BlackHole3D.BIM.setElemAlpha(dataSetId, [], 0);
    }
}

// 定位到数据集
export const focusToDataSet = (dataSetId) => {
    const BlackHole3D = window.BlackHole3D;
    BlackHole3D.BIM.delAllSelElems();

    BlackHole3D.Camera.setCamLocateToDataSet(dataSetId, 1.0);
}


// 重置构件属性
export const resetElemAttr = (dataSetId, elemIdList) => {
    const BlackHole3D = window.BlackHole3D;
    BlackHole3D.BIM.resetElemAttr(dataSetId, elemIdList);
}

// 高亮构件
export const highLightElems = (dataSetId, elemIdList, isFocus) => {
    const BlackHole3D = window.BlackHole3D;
    BlackHole3D.BIM.delAllSelElems();

    BlackHole3D.BIM.addToSelElems(dataSetId, elemIdList);
    if (isFocus) {
        const dataSetList = [{ dataSetId, elemIdList }]
        focusToElems(dataSetList)
    }


    setSelElemsBlendAttr()
}

// 定位到构件集合
export const focusToElems = (dataSetList) => {
    const BlackHole3D = window.BlackHole3D;
    const locIDList = dataSetList.map(item => {
        let obj = {
            dataSetId: item.dataSetId,
            elemIdList: item.elemIdList
        }
        return obj
    })
    BlackHole3D.Camera.setCamLocateToElem(locIDList, 1.0)
}

// 显示构件
export const showElems = (dataSetId, elemIdList) => {
    const BlackHole3D = window.BlackHole3D;
    BlackHole3D.BIM.delAllSelElems();
    BlackHole3D.BIM.resetElemAttr(dataSetId, elemIdList);
}

// 隐藏构件
export const hideElems = (dataSetId, elemIdList) => {
    const BlackHole3D = window.BlackHole3D;
    BlackHole3D.BIM.delAllSelElems();
    BlackHole3D.BIM.setElemAlpha(dataSetId, elemIdList, 0);
}

export const setSelElemsBlendAttr = () => {
    const BlackHole3D = window.BlackHole3D
    let blendAttr = BlackHole3D.BIM.getSelElemsBlendAttr()
    blendAttr.elemClr = new BlackHole3D.REColor(255, 0, 0, 200)
    blendAttr.clrWeight = 128
    blendAttr.alphaWeight = 200
    BlackHole3D.BIM.setSelElemsBlendAttr(blendAttr)
}
